// You can write more code here

/* START OF COMPILED CODE */

import Phaser from 'phaser';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class StatsBar extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 45, y ?? 15);

    // segment5
    const segment5 = scene.add.image(38, 0, 'common', 'meter-upgrade-border.png');
    this.add(segment5);

    // segment4
    const segment4 = scene.add.image(19, 0, 'common', 'meter-upgrade-border.png');
    this.add(segment4);

    // segment3
    const segment3 = scene.add.image(0, 0, 'common', 'meter-upgrade-border.png');
    this.add(segment3);

    // segment2
    const segment2 = scene.add.image(-19, 0, 'common', 'meter-upgrade-border.png');
    this.add(segment2);

    // segment1
    const segment1 = scene.add.image(-38, 0, 'common', 'meter-upgrade-border.png');
    this.add(segment1);

    // lists
    const segments = [segment1, segment2, segment3, segment4, segment5];

    this.segment5 = segment5;
    this.segment4 = segment4;
    this.segment3 = segment3;
    this.segment2 = segment2;
    this.segment1 = segment1;
    this.segments = segments;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private segment5: Phaser.GameObjects.Image;
  private segment4: Phaser.GameObjects.Image;
  private segment3: Phaser.GameObjects.Image;
  private segment2: Phaser.GameObjects.Image;
  private segment1: Phaser.GameObjects.Image;
  private segments: Phaser.GameObjects.Image[];
  public filledSegment: string = 'meter-upgrade-fill.png';
  public unfilledSegment: string = 'meter-upgrade-border.png';

  /* START-USER-CODE */

  public setFilledSegments(numUpgrades: number) {
    for (let i = 0; i < this.segments.length; i++) {
      const segment = this.segments[i];

      if (i < numUpgrades) segment.setFrame(this.filledSegment);
      else segment.setFrame(this.unfilledSegment);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
